import { userConstants } from '../_constants';
import { userService } from '../_services';

export const userActions = {
    login,
		logout,
		getUser,
		getUserSession,
		getUserAttributes
};

function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                session => { 
                    dispatch(success(session));
                    //history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    //dispatch(alertActions.error(error));
                }
            );
    };

    function request(username) { return { type: userConstants.LOGIN_REQUEST, username } }
    function success(session) { return { type: userConstants.LOGIN_SUCCESS, session } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function getUser(){
	return dispatch => {
    dispatch(request());
		userService.getUser()
			.then(
					user => {
						dispatch(success(user));
					},
					error => {
						dispatch(failure(error));
					}
			);
	};

	function request() { return { type: userConstants.GET_USER_REQUEST } }
	function success(user) { return { type: userConstants.GET_USER_SUCCESS, user } }
	function failure(error) { return { type: userConstants.GET_USER_FAILURE, error } }
}

function getUserSession() {
	return dispatch => {
		dispatch(request());
		userService.getUserSession()
			.then(
					session => {
						dispatch(success(session));
					},
					error => {
						dispatch(failure(error));
					}
			);
	}

	function request() { return { type: userConstants.GET_USER_SESSION_REQUEST } }
	function success(session) { return { type: userConstants.GET_USER_SESSION_SUCCESS, session } }
	function failure(error) { return { type: userConstants.GET_USER_SESSION_FAILURE, error } }
}

function getUserAttributes() {
	return dispatch => {
		dispatch(request());
		userService.getUserSession()
			.then(
				session  => {
					userService.getUserAttributes()
						.then(
								attributes => {
									dispatch(success(attributes));
								},
								error => {
									dispatch(failure(error));
								}
						);
					},
				error => {
					dispatch(failure(error));
				}
		);
	}
	
	function request() { return { type: userConstants.GET_USER_ATTRIBUTES_REQUEST } }
	function success(attributes) { return { type: userConstants.GET_USER_ATTRIBUTES_SUCCESS, attributes } }
	function failure(error) { return { type: userConstants.GET_USER_ATTRIBUTES_FAILURE, error } }
}

function logout() {
	userService.logout()
	return logoutSuccess();

	function logoutSuccess() { return { type: userConstants.LOGOUT } }
}



// WEBPACK FOOTER //
// ./src/_actions/user.js